import { createSlide } from "../slidesOps/createSlide";
export function missingSlide() {
    createSlide({
        wrap: "false",
        html: `
            <p style="max-width: 100%;text-align:left;">
                Ask, and it will be given to you;<br />
                seek, and you will find...
            </p>
        `,
        background: { color: "#000" },
    }, "error-404"); // error message instead
}
